export const getCurrencySymbol = (currency: string) => {
  const symbols: { [key: string]: string } = {
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
  };
  return symbols[currency] || "₹"; // Default to "$" if symbol is not found
};
